import { render } from "./EhliyetSinavi.vue?vue&type=template&id=39537d71"
import script from "./EhliyetSinavi.vue?vue&type=script&lang=js"
export * from "./EhliyetSinavi.vue?vue&type=script&lang=js"

import "./EhliyetSinavi.vue?vue&type=style&index=0&id=39537d71&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__